import { alertConstants } from '../consts/alertConsts';

export const alertActions = {
  success,
  error,
  clear,
  close,
};

function success(message) {
  return { type: alertConstants.SUCCESS, message };
}

function error(message) {
  if(typeof message != 'string') {
    message = 'Unknown error';
  }
  return { type: alertConstants.ERROR, message };
}

function clear() {
  return { type: alertConstants.CLEAR };
}

function close(id) {
  return { type: alertConstants.CLOSE_ALERT, id }
}